import * as React from 'react';

import { ListDetailStyles } from './ListDetailStyles';
import { ListPanelProps } from './types';

export const ListPanel: React.FC<ListPanelProps> = ({
  children,
  collapsed,
  testId = 'list-panel',
  className,
}) => {
  const panelClassName = collapsed
    ? `${ListDetailStyles.ListPanel} ${ListDetailStyles.ListPanelCollapsed} ${className || ''}`
    : `${ListDetailStyles.ListPanel} ${className || ''}`;

  return (
    <div
      data-tb-test-id={testId}
      className={panelClassName}
      aria-hidden={collapsed}
    >
      {!collapsed && (
        <div className={ListDetailStyles.ListContent}>
          {children}
        </div>
      )}
    </div>
  );
};

ListPanel.displayName = 'ListPanel';
